{
    "TelephoneserverLabel": "Servidor de telefonia:",
    "PartitionsLabel": "Partições:",
    "ScopeFiltering_SectionHeader": "Filtragem de Âmbito",
    "NAME": "ScopeFiltering",
    "ScopeGroupsLabel": "Grupo(s) de Âmbito:",
    "AnyScopeGroupsLabel": "[Qualquer Grupo de Âmbito]"
}